var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertCircleFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_24777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM7.82129 6.54688C7.46285 6.55064 7.13084 6.60174 6.13574 7.00293L6.01172 7.51758C6.98522 7.15458 7.40211 7.4211 7.34961 7.92285C7.33888 8.77118 6.61381 10.2866 6.6123 11.3154C6.59281 12.2289 7.53261 12.5293 8.05762 12.4971C8.57437 12.5061 8.88389 12.3808 9.74414 12.041L9.86816 11.5273C9.2022 11.8093 8.42366 11.7733 8.50391 11.1201C8.53855 10.1917 9.23911 8.76412 9.23926 7.72852C9.26251 6.99277 8.59154 6.49587 7.82129 6.54688ZM8.86816 3.5C8.28491 3.49041 7.73892 3.94659 7.74316 4.55078C7.73792 5.15893 8.29077 5.60628 8.86816 5.59668C9.44416 5.60718 9.99353 5.15978 9.98828 4.55078C9.99253 3.94723 9.45153 3.4895 8.86816 3.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_24777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleFull);
export default __webpack_public_path__ + "static/media/alert-circle-full.83959ca4232ea549f8e4fba6398c4cd7.svg";
export { ForwardRef as ReactComponent };